import gql from 'graphql-tag'
import {
	standardCompanyResult,
	standardArticleResult,
	companyOfficesResult,
	companyConnectionData,
} from 'store/fragments'

export const IndustriesQuery = gql`
	query industryCollection {
		industryCollection {
			edges {
				node {
					id
					key
				}
			}
		}
	}
`
export const CompaniesTypesQuery = gql`
	query companyTypeCollection {
		companyTypeCollection {
			edges {
				node {
					id
					title
				}
			}
		}
	}
`
export const CompaniesQuery = gql`
	query companies($filter: CompanyFilter) {
		companyCollection(filter: $filter) {
			edges {
				node {
					id
					name
					slug
				}
			}
		}
	}
`

export const CompanyQuery = gql`
	query company($id: String, $name: String, $slug: String) {
		companyCollection(
			filter: {
				id: { eq: $id }
				name: { ilike: $name }
				slug: { ilike: $slug }
			}
		) {
			edges {
				node {
					...standardCompanyResult
				}
			}
		}
	}
	${standardCompanyResult}
`

export const CompanyOffice = gql`
	query companyOffice($id: String) {
		companyOfficesCollection(filter: { id: { eq: $id } }) {
			edges {
				node {
					...companyOfficesResult
				}
			}
		}
	}
	${companyOfficesResult}
`

export const CompanyOffices = gql`
	query companyOffices($companySlug: String, $companyId: String) {
		companyOfficesCollection(
			filter: {
				# companyslug: {like:$companySlug}
				companyId: { like: $companyId }
			}
		) {
			edges {
				node {
					...companyOfficesResult
				}
			}
		}
	}
	${companyOfficesResult}
`

export const FeedCompaniesQuery = gql`
	query feedcompanies(
		$name: String
		$sizes: [String]
		$industryids: [String]
		$locationsids: [String]
		$after: Cursor
		$first: Int
	) {
		feedcompanies(
			name: $name
			sizes: $sizes
			industryids: $industryids
			locationids: $locationsids
			after: $after
			first: $first
		) {
			edges {
				node {
					...Node
				}
				cursor
			}
			pageInfo {
				...pageInfoData
			}
		}
	}
	${companyConnectionData}
`

// MUATTIONS

export const AddCompany = gql`
	mutation insertIntoCompanyCollection($details: [CompanyInsertInput!]!) {
		insertIntoCompanyCollection(objects: $details) {
			records {
				...standardCompanyResult
			}
		}
	}
	${standardCompanyResult}
`

export const UpdateCompanyDetails = gql`
	mutation updateCompanyCollection($details: CompanyUpdateInput!) {
		updateCompanyCollection(set: $details) {
			records {
				...standardCompanyResult
			}
		}
	}
	${standardCompanyResult}
`

export const HandleCompanyStory = gql`
	mutation insertIntoArticleCollection($story: [ArticleInsertInput!]!) {
		insertIntoArticleCollection(objects: $story) {
			records {
				...standardArticleResult
			}
		}
	}
	${standardArticleResult}
`

export const DeleteCompanyStory = gql`
	mutation deleteFromArticleCollection($storyId: String!) {
		deleteFromArticleCollection(filter: { id: { eq: $storyId } }) {
			records {
				...standardArticleResult
			}
		}
	}
	${standardArticleResult}
`

export const AddCompanyOffice = gql`
	mutation insertIntoCompanyOfficesCollection(
		$data: [CompanyOfficesInsertInput!]!
	) {
		insertIntoCompanyOfficesCollection(objects: $data) {
			records {
				...companyOfficesResult
			}
		}
	}
	${standardCompanyResult}
`

export const HandleCompanyOffices = gql`
	mutation handleCompanyOffices($data: CompanyOfficesUpdateInput!) {
		updateCompanyOfficesCollection(set: $data) {
			records {
				...companyOfficesResult
			}
		}
	}
	${companyOfficesResult}
`
export const DeleteCompanyOffice = gql`
	mutation deleteFromCompanyOfficesCollection($id: String) {
		deleteFromCompanyOfficesCollection(filter: { id: { eq: $id } }) {
			records {
				...companyOfficesResult
			}
		}
	}
	${standardCompanyResult}
`
export const ChangeCompanyHq = gql`
	mutation changeCompanyHq($companyId: String!, $officeId: String!) {
		resetHq: updateCompanyOfficesCollection(
			filter: { companyId: { eq: $companyId } }
			set: { hq: false }
		) {
			records {
				...companyOfficesResult
			}
		}
		setNewHq: updateCompanyOfficesCollection(
			filter: { id: { eq: $officeId } }
			set: { hq: true }
		) {
			records {
				...companyOfficesResult
			}
		}
	}
`

export const DeleteCompanyMutation = gql`
	mutation deleteCompanyMutation($id: String, $checkText: String!) {
		deleteFromCompanyCollection(filter: { id: { eq: $id } }) {
			records {
				...standardCompanyResult
			}
		}
	}
	${standardCompanyResult}
`

export const PublicCompanyQuery = gql`
	query publicCompanies($name: String) {
		public_companiesCollection(filter: { name: { eq: $name } }) {
			edges {
				node {
					id
					name
					header_path
					header_name
					header_mime
					original_header_path
					avatar_path
					avatar_name
					avatar_mime
					original_avatar_path
					website
					facebook
					instagram
					twitter
					about
					created_at
					updated_at
					location_id
					vision
					culture
					founded
					industry
					name
					created_by
					size
					linkedin
					tiktok
					company_testimonialsCollection {
						edges {
							node {
								id
								name
								avatar_path
								avatar_name
								avatar_mime_type
								role
								started_at
								review
								stars
								created_at
								updated_at
							}
						}
					}
					company_public_galleriesCollection {
						edges {
							node {
								id
								path
								name
								mime
								text
								created_at
								updated_at
							}
						}
					}
				}
				cursor
			}
		}
	}
`

export const PublicCompanyTeamsQuery = gql`
	query companyPublicTeams($companyId: String) {
		company_public_teamsCollection(
			filter: { public_company_id: { eq: $companyId } }
		) {
			edges {
				node {
					id
					public_company_id
					title
					description
					created_at
					image_path
					image_mime
					image_name
				}
			}
		}
	}
`
